"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var hovo_api_1 = require("../../shared/hovo-api");
var config_1 = require("../../shared/config");
var course_helper_1 = require("./course-helper");
var date_1 = require("../../shared/date");
var course_filtering_1 = require("./course-filtering");
(0, jquery_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    function applyHardFilters() {
        // Hard filters can also be set in HTML code.
        var studyId = $courses.data('study-id');
        if (studyId) {
            filteredCourses = filteredCourses.filter(function (c) { return c.study_id == studyId; });
        }
        var titleFilter = $courses.data("title-filter");
        if (titleFilter) {
            var titles_1 = titleFilter.split('|').map(function (s) { return s.trim().toLowerCase(); });
            filteredCourses = filteredCourses.filter(function (c) { return titles_1.filter(function (t) { return c.title.toLowerCase().includes(t); }).length > 0; });
        }
        var seasonFilter = $courses.data("season-filter");
        if (seasonFilter) {
            var seasons_1 = seasonFilter.split('|').map(function (s) { return s.trim().toLowerCase(); });
            filteredCourses = filteredCourses.filter(function (c) { return seasons_1.filter(function (t) { var _a; return (_a = c.season) === null || _a === void 0 ? void 0 : _a.title.toLowerCase().includes(t); }).length > 0; });
        }
        var methodFilter = $courses.data("method-filter");
        if (methodFilter) {
            var methods_1 = methodFilter.split('|').map(function (s) { return s.trim().toLowerCase(); });
            filteredCourses = filteredCourses.filter(function (c) { return methods_1.filter(function (t) { var _a; return (_a = c.method) === null || _a === void 0 ? void 0 : _a.title.toLowerCase().includes(t); }).length > 0; });
        }
        var locationIdFilter = $courses.data('location-id-filter');
        if (locationIdFilter) {
            filteredCourses = filteredCourses.filter(function (c) { var _a; return ((_a = c.locations) !== null && _a !== void 0 ? _a : []).some(function (loc) { var _a; return String((_a = loc.location) === null || _a === void 0 ? void 0 : _a.id) === String(locationIdFilter); }); });
        }
        var cityFilter = $courses.data('city-filter');
        if (cityFilter) {
            var cities_1 = cityFilter.split('|').map(function (s) { return s.trim().toLowerCase(); });
            filteredCourses = filteredCourses.filter(function (c) {
                return cities_1.filter(function (city) {
                    var _a, _b;
                    return ((_a = c.city) === null || _a === void 0 ? void 0 : _a.title.toLowerCase().includes(city)) ||
                        ((_b = c.locations) !== null && _b !== void 0 ? _b : []).filter(function (loc) { var _a, _b; return (_b = (_a = loc.location) === null || _a === void 0 ? void 0 : _a.city) === null || _b === void 0 ? void 0 : _b.title.toLowerCase().includes(city); }).length > 0;
                }).length > 0;
            });
        }
        var fieldFilter = $courses.data("field-filter");
        if (fieldFilter) {
            var fields_1 = fieldFilter.toString().split('|').map(function (s) { return s.trim().toLowerCase(); });
            filteredCourses = filteredCourses.filter(function (c) { return fields_1.filter(function (t) { var _a; return ((_a = c.field) === null || _a === void 0 ? void 0 : _a.title.toLowerCase().includes(t)) || c.field_id == t; }).length > 0; });
            console.log(filteredCourses);
        }
    }
    function initializeCourses() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var $courseTemplate = (0, jquery_1.default)('#course-template');
        if (!$courseTemplate.length) {
            console.error("No element with ID course-template found!");
            return;
        }
        $courseTemplate = $courseTemplate.clone();
        $courseTemplate.show();
        $courses.empty();
        for (var _i = 0, filteredCourses_1 = filteredCourses; _i < filteredCourses_1.length; _i++) {
            var course = filteredCourses_1[_i];
            var $course = $courseTemplate.clone();
            // Set course image(s)
            $course.find('img[data-field="thumbnail"]').attr("src", course.thumbnail);
            var backgroundImgDiv = $course.find('*[data-field="course-background-image"]');
            if (backgroundImgDiv.length) {
                backgroundImgDiv.css('background-image', "url(".concat(course.jumbotronUrl, ")"));
            }
            $course.find('*[data-field="title-only"]').text("".concat(course.title));
            $course.find('*[data-field="title"]').text("".concat(course.course_number, " - ").concat(course.title));
            $course.find('*[data-field="description-short"]').html(course.description_short);
            $course.find('*[data-field="more-info-url"]').attr("href", "".concat(config.coursePage).concat(course.id, "-").concat(course.slug));
            var $subscribeButton = $course.find('*[data-field="subscribe-button"]');
            $subscribeButton.attr("data-course-id", course.id);
            $subscribeButton.attr("data-waitinglist", course.waitinglist);
            $subscribeButton.text(course.waitinglist ? "inschrijven wachtlijst" : "inschrijven");
            var location = !!course.locations && course.locations.length ? (_a = course.locations[0].location) === null || _a === void 0 ? void 0 : _a.title : '';
            $course.find('*[data-field="day"]').text(course.day);
            $course.find('*[data-field="city"]').text((_b = course.city) === null || _b === void 0 ? void 0 : _b.title);
            $course.find('*[data-field="location"]').text(location);
            $course.find('*[data-field="season"]').text((_d = (_c = course.season) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : "");
            $course.find('*[data-field="field"]').text((_f = (_e = course.field) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : "");
            $course.find('*[data-field="startDate"]').text((_g = course.startDateDisplay) !== null && _g !== void 0 ? _g : "");
            $course.find('*[data-field="subscribeUntil"]').text((0, date_1.formatDate)((_h = course.subscribe_till) !== null && _h !== void 0 ? _h : "", 'dd D MMM YYYY'));
            // Teachers
            $course.find('*[data-field="teachers"]').html(course.teachers.map(function (t) { return "<span>".concat(t.fullname, "</span>"); }).join("<br />"));
            if (course.teachers.length > 0) {
                // Find the first teacher image and set it in the template.
                var teacher = course.teachers[0];
                var imageUrl = teacher.imageUrl;
                var $teacherPhoto = $course.find('*[data-field="teacher-photo"]');
                if ($teacherPhoto.length) {
                    $teacherPhoto.attr('src', imageUrl);
                    $teacherPhoto.attr('alt', teacher.fullname);
                    $teacherPhoto.attr('title', teacher.fullname);
                }
            }
            //primaryteacher
            $course.find('*[data-field="primaryTeacher"]').html(course.teachers.slice(0, 1).map(function (t) { return "<span>".concat(t.fullname, "</span>"); }).join(""));
            if (course.teachers.length > 0) {
                // Find the first teacher image and set it in the template.
                var teacher = course.teachers[0];
                var imageUrl = teacher.imageUrl;
                var $teacherPhoto = $course.find('*[data-field="teacher-photo"]');
                if ($teacherPhoto.length) {
                    $teacherPhoto.attr('src', imageUrl);
                    $teacherPhoto.attr('alt', teacher.fullname);
                    $teacherPhoto.attr('title', teacher.fullname);
                }
            }
            // Waitinglist
            if (course.waitinglist && !course.is_external) {
                $course.find('*[data-field="waitinglist"]').show();
            }
            // External course
            if (course.is_external) {
                if (window.location.pathname.replace(/\/+$/, '') === '/ons-onderwijsaanbod/nijmegen') {
                    $course.find('*[data-field="external-course"]').show();
                }
            }
            // Course already started
            if (course.courseStarted) {
                $course.find('*[data-field="course-started"]').show();
            }
            $course.find(".subscribe").on("click", function (e) {
                (0, course_helper_1.handleSubscribeLinkClick)(e, (0, jquery_1.default)(this));
            });
            var $icon = $course.find(".icon");
            if ($icon.length && course.icon) {
                $icon.append("<img src=\"".concat(course.icon, "\" />"));
            }
            $courses.append($course);
        }
        (0, jquery_1.default)(document).trigger("coursesInitialized", [filteredCourses, availableCourses]);
    }
    var $courses, courses, isHovoUtrechtOverview, visibleCourses, filteredCourses, config, availableCourses, initialFieldFilter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                $courses = (0, jquery_1.default)('#courses-list');
                if (!$courses.length) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, (0, hovo_api_1.getCourses)()];
            case 1:
                courses = _a.sent();
                isHovoUtrechtOverview = window.location.hostname.replace(/^www\./, '') === 'hovoutrecht.nl' &&
                    window.location.pathname.replace(/\/+$/, '') === '/ons-onderwijsaanbod';
                visibleCourses = isHovoUtrechtOverview
                    ? courses.filter(function (course) { return !course.is_external; })
                    : courses;
                filteredCourses = visibleCourses;
                config = (0, config_1.getHovoThemeConfig)();
                applyHardFilters();
                availableCourses = filteredCourses;
                initialFieldFilter = $courses.attr("data-initial-field-filter");
                if (initialFieldFilter) {
                    filteredCourses = (0, course_filtering_1.filterCourses)(availableCourses, { vakgebied: initialFieldFilter });
                }
                // This event listener is triggered when any of the filters in the widget has changed.
                // Update the courses list based on the filter.
                (0, jquery_1.default)(document).on("courseFilterChanged", function (e, filter) {
                    filteredCourses = (0, course_filtering_1.filterCourses)(availableCourses, filter);
                    initializeCourses();
                });
                initializeCourses();
                return [2 /*return*/];
        }
    });
}); });
